// extracted by mini-css-extract-plugin
export default {"container":"Testimonials_container__G8+x0","loaded":"Testimonials_loaded__ulAZw","title":"Testimonials_title__pAKkl"};